export const zoom = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect opacity="0.7" width="24" height="24" rx="4" fill="#41444F"/>
<path d="M6 10H4V5C4 4.4 4.4 4 5 4H10V6H6V10Z" fill="white"/>
<path d="M20 10H18V6H14V4H19C19.6 4 20 4.4 20 5V10Z" fill="white"/>
<path d="M19 20H14V18H18V14H20V19C20 19.6 19.6 20 19 20Z" fill="white"/>
<path d="M10 20H5C4.4 20 4 19.6 4 19V14H6V18H10V20Z" fill="white"/>
</svg>
`;
